import React from 'react';
import { Button, Card, Typography, Space } from 'antd';
import { MailOutlined, LoginOutlined } from '@ant-design/icons';
import { useLogout } from '../../hooks/useLogout';
import ToastMsg from '../common/ToastMsg';

const { Title, Text } = Typography;

const NewUserEmailVerificationPage: React.FC = () => {
  console.info('NewUserEmailVerificationPage mounted');
  const { logout } = useLogout();

  const handleLoginAgain = async () => {
    console.info('Login Again button clicked');
    try {
      // Logout current user without redirect
      console.info('Logging out user for email verification');
      await logout({ returnTo: '/login?auto=true' });
    } catch (error) {
      console.error('Error during logout and redirect:', error);
      ToastMsg('error', 'Failed to redirect to login. Please try again.');
    }
  };

  return (
    <div style={{ 
      minHeight: '100vh', 
      display: 'flex', 
      justifyContent: 'center', 
      alignItems: 'center',
      background: '#f0f2f5',
      padding: '20px'
    }}>
      <Card style={{ 
        maxWidth: 500, 
        width: '100%', 
        textAlign: 'center',
        boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
        borderRadius: '8px'
      }}>
        <MailOutlined style={{ fontSize: 'clamp(32px, 5vw, 48px)', color: '#0056D2', marginBottom: 24 }} />
        <Title level={2} style={{ fontSize: 'clamp(20px, 4vw, 24px)' }}>Verify Your Email</Title>
        <Text style={{ 
          display: 'block', 
          marginBottom: 24,
          fontSize: 'clamp(14px, 2vw, 16px)'
        }}>
          Please check your email and verify your account before continuing.
        </Text>
        <Text type="secondary" style={{ 
          display: 'block', 
          marginBottom: 32,
          fontSize: 'clamp(12px, 1.5vw, 14px)'
        }}>
          After verifying your email, click the button below to log in with your verified account.
        </Text>
        <Space direction="vertical" size="large" style={{ width: '100%' }}>
          <Button
            type="primary"
            icon={<LoginOutlined />}
            onClick={handleLoginAgain}
            size="large"
            block
          >
            Login Again
          </Button>
        </Space>
      </Card>
    </div>
  );
};

export default NewUserEmailVerificationPage; 